// API 基础配置
const API_BASE_URL = "https://kawa-backend.gxxushang.com"; // 实际API地址

// 图片地址
const IMAGE_BASE_URL = "https://kawa-static-ali.gxxushang.com/"; // 实际API地址

// API 版本
const API_VERSION = "1.0";

// 是否启用AES加密
const ENABLE_AES = false;

// 超时时间（毫秒）
const TIMEOUT = 10000;

// 内容类型
const CONTENT_TYPE = "application/json;charset=UTF-8";

export {
  API_BASE_URL,
  API_VERSION,
  ENABLE_AES,
  TIMEOUT,
  CONTENT_TYPE,
  IMAGE_BASE_URL
} 